import { useCallback, useState } from 'react';
import { apiClient } from '../services/apiClient';
import { GeneralConfig } from '../types/generalConfig';

export const useGeneralPermissions = () => {
  const [permissions, setPermissions] = useState<GeneralConfig | null>(null);
  const [loadingPermissions, setLoadingPermissions] = useState(true);

  const loadPermissions = useCallback(async () => {
    try {
      setLoadingPermissions(true);
      const response = await apiClient.get<GeneralConfig>('/general/permission');
      const permissionsData = response.data ?? response;
      setPermissions(permissionsData);
    } catch (error) {
      console.error('Failed to load general permissions:', error);
      // Don't show error to user, just log it - this is non-critical
    } finally {
      setLoadingPermissions(false);
    }
  }, []);

  return {
    permissions,
    loadingPermissions,
    loadPermissions
  };
};
